<!--
  ~ Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->

<og-labeled-entity [label]="label" [size]="size">
  <ng-content content select="[content]"></ng-content>
</og-labeled-entity>
